// extracted by mini-css-extract-plugin
export default {"sortIconActive":"SortingIcons_sortIconActive__wHuRP","sortIcon":"SortingIcons_sortIcon__-ot35"};